import css from '@emotion/css';
import {
  styled,
  minimumWidth,
  pxToRem,
  ValueIndicatorList,
} from '@feast-it/ui/light';

export const Section = styled.section(
  ({ theme }) => css`
    background-color: ${theme.colors.lightGrey};
    padding: ${theme.spacing[10]} ${theme.spacing[4]};

    ${minimumWidth(theme.breakpoints.small)} {
      padding: ${theme.spacing[10]} ${theme.spacing[8]};
    }

    ${minimumWidth(theme.breakpoints.medium)} {
      padding: ${theme.spacing[10]} ${theme.spacing[10]};
    }
  `
);

export const Container = styled.div<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    width: 100%;
    background-color: ${isDark ? theme.colors.black : theme.colors.white};
    border: ${isDark ? `${pxToRem(1)} solid ${theme.colors.white}` : 'none'};
    padding: ${theme.spacing[10]} ${theme.spacing[4]};

    ${minimumWidth(theme.breakpoints.small)} {
      padding: ${theme.spacing[10]} ${theme.spacing[8]};
    }

    ${minimumWidth(theme.breakpoints.medium)} {
      padding: ${theme.spacing[10]} ${theme.spacing[10]};
    }
  `
);

export const BenefitsHeading = styled.h2<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    font-family: ${theme.textStyles.headingLarge.fontFamily};
    text-align: center;
    color: ${isDark ? theme.colors.white : theme.colors.black};
    font-size: ${pxToRem(28)};
    line-height: 1.3;
    margin-bottom: ${theme.spacing[6]};

    ${minimumWidth(theme.breakpoints.small)} {
      font-size: ${pxToRem(32)};
    }

    ${minimumWidth(theme.breakpoints.medium)} {
      font-size: ${pxToRem(40)};
    }
  `
);

export const StyledValueIndicatorList = styled(ValueIndicatorList)<{
  isDark?: boolean;
}>(
  ({ theme, isDark }) => css`
    background-color: ${isDark ? theme.colors.black : theme.colors.white};
    color: ${isDark ? theme.colors.white : theme.colors.black};

    /* ValueIndicatorList's list items (and their tick icons) hardcode their
       own color, so the dark override has to win explicitly rather than
       via inheritance. */
    li {
      color: ${isDark ? theme.colors.white : theme.colors.black} !important;

      > div {
        color: ${isDark
          ? theme.colors.paleYellow
          : theme.colors.mediumBlue} !important;
        fill: ${isDark
          ? theme.colors.paleYellow
          : theme.colors.mediumBlue} !important;
      }
    }
  `
);
